import { useEffect, useState } from 'react';
import OrderApi from '../../Api/OrderApi';
import { Order } from '../../Models/Order';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import { displayDateOnly, formatNumbers } from '../../Utils';
import { FileTypeEnums } from '../../Models/FileType';
import blankImage from '../../Assets/NoPhoto.jpg';
import { FaChevronDown } from 'react-icons/fa';

export default function OrderList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [loading, setIsLoading] = useState<boolean>();
  const [ordersData, setOrdersData] = useState<Order[] | null>(null);

  const getOrders = () => {
    if (userModel) {
      setIsLoading(true);
      OrderApi.getUserOrders(userModel!.id)
        .then((res) => {
          setOrdersData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    getOrders();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className='w-full mt-4'>
        <div className='container mx-auto p-2'>
          <div className='mb-2 border-b-2 flex justify-between'>
            <h1 className='text-gray-900 font-bold text-4xl'>Your Orders:</h1>
          </div>
          <div className='h-[calc(100vh-142px)] md:h-[calc(100vh-210px)] overflow-y-auto'>
            {ordersData?.map((order) => (
              <div key={order.id} className='mb-5'>
                <div className='flex gap-5 w-full bg-gray-50 p-2'>
                  <div>
                    <div>Order Placed</div>
                    <div className='p-1'>
                      {displayDateOnly(
                        order.dateSubmitted
                          ? new Date(order.dateSubmitted)
                          : null
                      )}
                    </div>
                  </div>
                  <div>
                    <div>Total</div>
                    <div className='p-1'>
                      $
                      {formatNumbers(
                        order.orderItems?.reduce(
                          (acc, item) =>
                            acc + item.quantity * (item.equipment?.price ?? 0),
                          0
                        )
                      )}
                    </div>
                  </div>
                  <div>
                    <div>Delivered To</div>
                    <div className='hover:bg-gray-100 rounded-md'>
                      <div className='group relative flex max-w-max flex-col items-center justify-center'>
                        <div className='flex cursor-pointer p-1'>
                          {order.contactName}
                          <FaChevronDown className='mx-2 my-auto' />
                        </div>
                        <div className='absolute left-1/2 top-10 ml-auto mr-auto min-w-max -translate-x-1/2 scale-0 transform rounded-lg px-3 py-2 text-xs font-medium transition-all duration-300 group-hover:scale-100'>
                          <div className='flex max-w-xs flex-col items-center shadow-lg'>
                            <div className='clip-bottom h-2 w-4 bg-gray-800'></div>
                            <div className='rounded bg-gray-800 p-2 text-center text-xs text-white'>
                              <div>
                                <div>{order.shippingAddress?.address1} </div>
                                <div>
                                  {order.shippingAddress?.city}
                                  {', '}
                                  {order.shippingAddress?.state?.name}{' '}
                                  {order.shippingAddress?.zip}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='flex flex-col gap-5 w-full border-l-2 border-b-2 border-r-2 border-gray-50 p-2 items-start'>
                  {order.orderItems?.map((item) => (
                    <div key={item.id} className='flex justify-center'>
                      <img
                        key={item.id}
                        src={
                          item.equipment?.files &&
                          item.equipment?.files?.filter(
                            (x) => x.fileTypeId === FileTypeEnums.Photo
                          ).length > 0
                            ? item.equipment?.files.filter(
                                (x) => x.fileTypeId === FileTypeEnums.Photo
                              )[0].fileUrl
                            : blankImage
                        }
                        alt={item.equipment?.number + '-image'}
                        className='h-[150px] object-contain m-auto'
                      />
                      <div className='ml-2'>
                        <div>
                          Manufacturer: {item.equipment?.manufacturer?.name}
                        </div>
                        <div>Part #: {item.equipment?.number}</div>
                        <div>Quantity: {item.quantity}</div>
                        <div>
                          Price Estimate: $
                          {formatNumbers(
                            (item.equipment?.price ?? 1) * item.quantity
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
